import Vue from 'vue'
import Router from 'vue-router'
import Qiu from '../views/qiu.vue'
import Admin from '../views/Admin.vue'
import WinnersList from '../views/WinnersList.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Qiu',
      component: Qiu
    },
    {
      path: '/admin',
      name: 'Admin',
      component: Admin
    },
    {
      path: '/winners',
      name: 'WinnersList',
      component: WinnersList
    }
  ]
})